(function(){
'use strict';
const ROWS=['A','B','C','D','E','F','G','H'];
const COLS=[1,2,3,4,5,6,7,8,9,10,11,12];
const TYPES=[
  {v:'sandwich',l:'Sandwich',d:'Signal ↑ with concentration'},
  {v:'competitive',l:'Competitive',d:'Signal ↓ with concentration'},
  {v:'direct',l:'Direct',d:'Labelled primary antibody'},
  {v:'indirect',l:'Indirect',d:'Labelled secondary antibody'},
];
const LS_KEY='ab_elisa_analyser_v1';
const SVG_W=580,SVG_H=380;
const PAD={top:28,right:28,bottom:74,left:72};

let _cc=null,_ch='';
let S={
  elisaType:'sandwich',units:'pg/ml',customUnits:'',
  assayName:'',analyst:'',runDate:'',notes:'',cvThresh:15,
  standards:[
    {id:'STD1',conc:'2000',od1:'',od2:''},
    {id:'STD2',conc:'1000',od1:'',od2:''},
    {id:'STD3',conc:'500', od1:'',od2:''},
    {id:'STD4',conc:'250', od1:'',od2:''},
    {id:'STD5',conc:'125', od1:'',od2:''},
    {id:'STD6',conc:'62.5',od1:'',od2:''},
    {id:'STD7',conc:'31.25',od1:'',od2:''},
    {id:'Blank',conc:'0',  od1:'',od2:''},
  ],
  layout:null,ods:null,dilutions:{},
  plateMode:'layout',focusedCell:null,
  logScale:false,showGrid:true,showEq:true,
  curveColor:'#0A66C2',ptColor:'#D50019',ptSize:5,
};

function makeDefaultLayout(){
  const L=Array.from({length:8},()=>Array(12).fill(''));
  ['STD1','STD2','STD3','STD4','STD5','STD6','STD7','Blank'].forEach((n,i)=>{L[i][0]=n;L[i][1]=n;});
  let s=1;
  for(let c=2;c<12;c++) for(let rp=0;rp<4;rp++){L[rp*2][c]='S'+s;L[rp*2+1][c]='S'+s;s++;}
  return L;
}

/* ── MATH ── */
function gaussElim(M){
  const n=M.length,A=M.map(r=>[...r]);
  for(let col=0;col<n;col++){
    let mx=col;
    for(let r=col+1;r<n;r++) if(Math.abs(A[r][col])>Math.abs(A[mx][col])) mx=r;
    [A[col],A[mx]]=[A[mx],A[col]];
    if(Math.abs(A[col][col])<1e-14) return null;
    for(let r=col+1;r<n;r++){const f=A[r][col]/A[col][col];for(let j=col;j<=n;j++)A[r][j]-=f*A[col][j];}
  }
  const x=Array(n).fill(0);
  for(let i=n-1;i>=0;i--){x[i]=A[i][n];for(let j=i+1;j<n;j++)x[i]-=A[i][j]*x[j];x[i]/=A[i][i];}
  return x;
}
function polyFit(pts){
  if(!pts||pts.length<3) return null;
  const n=pts.length;let s0=n,s1=0,s2=0,s3=0,s4=0,t0=0,t1=0,t2=0;
  for(const {x,y} of pts){s1+=x;s2+=x*x;s3+=x*x*x;s4+=x*x*x*x;t0+=y;t1+=x*y;t2+=x*x*y;}
  const sol=gaussElim([[s4,s3,s2,t2],[s3,s2,s1,t1],[s2,s1,s0,t0]]);
  return sol?{a:sol[0],b:sol[1],c:sol[2]}:null;
}
function evalPoly(od,co){return co?co.a*od*od+co.b*od+co.c:null;}
function r2Score(pts,co){
  if(!co||pts.length<2) return null;
  const mean=pts.reduce((s,p)=>s+p.y,0)/pts.length;
  const ssTot=pts.reduce((s,p)=>s+(p.y-mean)**2,0);
  const ssRes=pts.reduce((s,p)=>s+(p.y-evalPoly(p.x,co))**2,0);
  return ssTot<1e-14?1:Math.max(0,1-ssRes/ssTot);
}
function stddev(arr){if(arr.length<2)return 0;const m=arr.reduce((a,x)=>a+x,0)/arr.length;return Math.sqrt(arr.reduce((s,x)=>s+(x-m)**2,0)/(arr.length-1));}
function cv(arr){if(arr.length<2)return null;const m=arr.reduce((a,x)=>a+x,0)/arr.length;return m<=0?null:(stddev(arr)/m)*100;}

function getBlankOD(){
  const b=S.standards.find(s=>s.id==='Blank');if(!b)return 0;
  const vs=[parseFloat(b.od1),parseFloat(b.od2)].filter(v=>!isNaN(v)&&v>=0);
  return vs.length?vs.reduce((a,x)=>a+x,0)/vs.length:0;
}
function getStdPoints(){
  const blankOD=getBlankOD(),isComp=S.elisaType==='competitive';
  return S.standards.filter(s=>{
    const c=parseFloat(s.conc),v1=parseFloat(s.od1),v2=parseFloat(s.od2);
    return !isNaN(c)&&(!isNaN(v1)||!isNaN(v2));
  }).map(s=>{
    const vs=[parseFloat(s.od1),parseFloat(s.od2)].filter(v=>!isNaN(v)&&v>=0);
    const avg=vs.reduce((a,x)=>a+x,0)/vs.length;
    const corr=isComp?avg:avg-blankOD;
    return{id:s.id,avg,corr,x:corr,y:parseFloat(s.conc),isBlank:s.id==='Blank'};
  }).filter(p=>!isNaN(p.x)&&!isNaN(p.y));
}
function getCoeffs(){
  const hash=JSON.stringify(S.standards)+S.elisaType;
  if(hash!==_ch){_cc=null;_ch=hash;}
  if(_cc!==null) return _cc;
  _cc=polyFit(getStdPoints());
  return _cc;
}
function getCurveRange(){
  const pts=getStdPoints().filter(p=>!p.isBlank);if(!pts.length)return null;
  const xs=pts.map(p=>p.x);return{min:Math.min(...xs),max:Math.max(...xs)};
}
function interpolate(sampleOD){
  const co=getCoeffs();if(!co)return null;
  const isComp=S.elisaType==='competitive';
  return evalPoly(isComp?sampleOD:sampleOD-getBlankOD(),co);
}
function computeResults(){
  const stdIds=new Set(S.standards.map(s=>s.id));
  const sampleWells={};
  ROWS.forEach((_,r)=>COLS.forEach((_,c)=>{
    const name=S.layout[r][c],od=parseFloat(S.ods[r][c]);
    if(!name||stdIds.has(name)||isNaN(od)||od<0)return;
    if(!sampleWells[name])sampleWells[name]=[];
    sampleWells[name].push({od,well:ROWS[r]+(c+1),row:r,col:c});
  }));
  const co=getCoeffs(),blankOD=getBlankOD(),range=getCurveRange(),isComp=S.elisaType==='competitive';
  return Object.entries(sampleWells).map(([name,wells])=>{
    const ods=wells.map(w=>w.od);
    const avgOD=ods.reduce((a,x)=>a+x,0)/ods.length;
    const corrOD=isComp?avgOD:avgOD-blankOD;
    const rawConc=co?evalPoly(corrOD,co):null;
    const df=parseFloat(S.dilutions[name])||1;
    const finalConc=rawConc!==null?rawConc*df:null;
    const repConcs=wells.map(w=>{const c=isComp?w.od:w.od-blankOD;return co?evalPoly(c,co)*df:null;}).filter(x=>x!==null&&x>0);
    const cvPct=repConcs.length>=2?cv(repConcs):null;
    const oor=range?corrOD<range.min*0.95||corrOD>range.max*1.05:false;
    return{name,wells,ods,avgOD,corrOD,rawConc,df,finalConc,repConcs,cvPct,oor,n:wells.length};
  }).sort((a,b)=>a.name.localeCompare(b.name,undefined,{numeric:true}));
}

/* ── FORMAT ── */
function fe(v,d=4){if(v===null||v===undefined||isNaN(v))return '-';const a=Math.abs(v);if(a===0)return '0';if(a>=0.001&&a<100000)return parseFloat(v.toFixed(d)).toString();return v.toExponential(3);}
function fSci(v){if(v===null||v===undefined||isNaN(v))return '-';const a=Math.abs(v);if(a>=0.0001&&a<100000)return v.toPrecision(6).replace(/\.?0+$/,'');return v.toExponential(4);}
function fConc(v){if(v===null||v===undefined||isNaN(v))return '-';return parseFloat(v.toFixed(2)).toLocaleString();}
function getUnits(){return S.units==='custom'?S.customUnits||'?':S.units;}

/* ── STANDARDS TABLE ── */
function renderStdTable(){
  const blankOD=getBlankOD(),u=getUnits(),isComp=S.elisaType==='competitive';
  const tbody=document.getElementById('ab-std-tbody');if(!tbody)return;
  tbody.innerHTML='';
  S.standards.forEach((s,i)=>{
    const vs=[parseFloat(s.od1),parseFloat(s.od2)].filter(v=>!isNaN(v)&&v>=0);
    const avg=vs.length?vs.reduce((a,x)=>a+x,0)/vs.length:null;
    const corr=avg!==null?(isComp?avg:avg-blankOD):null;
    const isBlank=s.id==='Blank';
    const tr=document.createElement('tr');
    tr.style.background=i%2===0?'transparent':'#FAFBFC';
    tr.innerHTML=`
      <td style="font-weight:700;color:${isBlank?'var(--ab-green)':'var(--ab-blue)'};font-size:11px">${s.id}</td>
      <td style="padding:4px 8px"><input type="number" class="ab-ea-inp ab-ea-inp-w80" value="${s.conc}" ${isBlank?'disabled':''} onchange="abEA.updateStd(${i},'conc',this.value)" step="any" min="0"></td>
      <td style="padding:4px 8px"><input type="number" class="ab-ea-inp ab-ea-inp-w60" value="${s.od1}" onchange="abEA.updateStd(${i},'od1',this.value)" step="0.001" min="0" placeholder="0.000"></td>
      <td style="padding:4px 8px"><input type="number" class="ab-ea-inp ab-ea-inp-w60" value="${s.od2}" onchange="abEA.updateStd(${i},'od2',this.value)" step="0.001" min="0" placeholder="0.000"></td>
      <td class="mono blue">${avg!==null?fe(avg,4):'-'}</td>
      <td class="mono" style="color:${corr!==null?'var(--ab-green)':'var(--ab-n400)'}">${corr!==null?fe(corr,4):isBlank?'0.0000':'-'}</td>
      <td>${isBlank||i<2?'':i>=2?`<button onclick="abEA.removeStd(${i})" style="background:none;border:none;cursor:pointer;color:var(--ab-n400);font-size:14px;padding:0 4px">×</button>`:''}</td>`;
    tbody.appendChild(tr);
  });
  const n=document.getElementById('ab-blank-notice');
  if(n){
    n.className=isComp?'ab-ea-notice ab-ea-notice-amber':'ab-ea-notice ab-ea-notice-blue';
    n.innerHTML=isComp?'<b>Competitive ELISA:</b> Raw OD used - no blank subtraction.':`<b>Blank OD:</b> ${fe(blankOD,4)} - subtracted from all ODs before interpolation.`;
  }
  _cc=null;
  renderCurveInfo();
}

/* ── CURVE INFO ── */
function renderCurveInfo(){
  const pts=getStdPoints(),co=getCoeffs(),r2=co?r2Score(pts,co):null,u=getUnits();
  const needMore=document.getElementById('ab-need-more'),coeffsCard=document.getElementById('ab-coeffs-card');
  const r2pill=document.getElementById('ab-r2-pill'),r2big=document.getElementById('ab-r2-big'),r2desc=document.getElementById('ab-r2-desc');
  if(pts.length>0&&pts.length<3){needMore&&(needMore.style.display='flex');coeffsCard&&(coeffsCard.style.display='none');r2pill&&(r2pill.style.display='none');renderChart(null,[]);return;}
  needMore&&(needMore.style.display='none');
  if(!co){coeffsCard&&(coeffsCard.style.display='none');r2pill&&(r2pill.style.display='none');renderChart(null,[]);return;}
  coeffsCard&&(coeffsCard.style.display='block');
  document.getElementById('ab-coeff-a').textContent=fSci(co.a);
  document.getElementById('ab-coeff-b').textContent=fSci(co.b);
  document.getElementById('ab-coeff-c').textContent=fSci(co.c);
  const sign=v=>v>=0?'+':'';
  document.getElementById('ab-eq-text').innerHTML=`Conc (${u}) = ${fSci(co.a)} &times; OD&sup2; ${sign(co.b)} ${fSci(co.b)} &times; OD ${sign(co.c)} ${fSci(co.c)}`;
  if(r2!==null){
    const r2v=r2.toFixed(5),good=r2>0.999,ok=r2>0.990;
    const col=good?'var(--ab-green)':ok?'var(--ab-blue)':'var(--ab-red)';
    const bg=good?'var(--ab-green-w)':ok?'var(--ab-blue-w)':'var(--ab-red-w)';
    const bdr=good?'rgba(46,125,50,.25)':ok?'rgba(10,102,194,.25)':'rgba(213,0,25,.25)';
    r2big&&(r2big.style.cssText=`background:${bg};color:${col};border:1px solid ${bdr}`)&&(r2big.textContent='R² = '+r2v);
    if(r2big){r2big.style.cssText=`background:${bg};color:${col};border:1px solid ${bdr}`;r2big.textContent='R² = '+r2v;}
    r2desc&&(r2desc.textContent=good?'Excellent fit':ok?'Good fit':'Poor fit - verify standards');
    r2pill&&(r2pill.style.display='')&&(r2pill.textContent='R² '+r2v);
    if(r2pill){r2pill.style.display='';r2pill.textContent='R² '+r2v;}
    const cw=document.getElementById('ab-curve-warning');
    const pnb=pts.filter(p=>!p.isBlank).sort((a,b)=>a.x-b.x);
    let mono=true;
    for(let i=1;i<pnb.length;i++) if((pnb[i].y-pnb[i-1].y)*(pnb.length>1?pnb[1].y-pnb[0].y:1)<0){mono=false;break;}
    cw&&(cw.style.display=mono?'none':'flex');
  } else { r2pill&&(r2pill.style.display='none'); }
  renderChart(co,pts);
  updateStatusBar();
}

/* ── SVG CHART ── */
function niceStep(raw){const p=Math.pow(10,Math.floor(Math.log10(raw)));const f=raw/p;if(f<1.5)return p;if(f<3.5)return 2*p;if(f<7.5)return 5*p;return 10*p;}
function renderChart(co,pts){
  const empty=document.getElementById('ab-chart-empty'),svgEl=document.getElementById('ab-chart-svg');
  if(!co||!pts||pts.length<3){empty&&(empty.style.display='flex');svgEl&&(svgEl.style.display='none');return;}
  empty&&(empty.style.display='none');svgEl&&(svgEl.style.display='block');
  const u=getUnits();
  const chartSub=document.getElementById('ab-chart-sub');
  chartSub&&(chartSub.textContent=`${S.elisaType.charAt(0).toUpperCase()+S.elisaType.slice(1)} ELISA · x = Corrected OD · y = Concentration (${u})`);
  const allX=pts.map(p=>p.x),allY=pts.map(p=>p.y);
  const xMin=Math.min(0,...allX),xMax=Math.max(...allX)*1.08,yMin=0,yMax=Math.max(...allY)*1.1;
  const W=SVG_W,H=SVG_H,P=PAD,cW=W-P.left-P.right,cH=H-P.top-P.bottom;
  const tx=x=>P.left+(x-xMin)/(xMax-xMin)*cW;
  const ty=y=>P.top+cH-(y-yMin)/(yMax-yMin)*cH;
  const fmtY=v=>v>=10000?(v/1000).toFixed(1)+'k':v>=1000?(v/1000).toFixed(2)+'k':v.toFixed(v>=10?1:2);
  const fmtX=v=>v.toFixed(3);
  // Curve
  let curvePts=[];
  for(let i=0;i<=250;i++){const x=xMin+(xMax-xMin)*i/250;const y=evalPoly(x,co);if(y!==null)curvePts.push([tx(x).toFixed(1),ty(y).toFixed(1)]);}
  const curveD=curvePts.map((p,i)=>(i===0?'M':'L')+p[0]+' '+p[1]).join(' ');
  // Ticks
  const yTicks=[],yStep=niceStep(yMax/5);
  for(let v=0;v<=yMax+yStep;v+=yStep) if(v<=yMax*1.05) yTicks.push(v);
  const xTicks=[],xStep=niceStep((xMax-xMin)/5);
  for(let v=Math.ceil(xMin/xStep)*xStep;v<=xMax+xStep*0.01;v+=xStep) xTicks.push(parseFloat(v.toFixed(6)));
  const cc=S.curveColor||'#0A66C2',pc=S.ptColor||'#D50019',ps=S.ptSize||5;

  let svg=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" id="ab-chart-svg-inner">`;
  svg+=`<rect width="${W}" height="${H}" fill="#fff"/>`;
  if(S.showGrid){
    yTicks.forEach(v=>{const y=ty(v);if(y>=P.top&&y<=H-P.bottom)svg+=`<line x1="${P.left}" y1="${y.toFixed(1)}" x2="${W-P.right}" y2="${y.toFixed(1)}" stroke="#EEF0F5" stroke-width="1"/>`;});
    xTicks.forEach(v=>{const x=tx(v);if(x>=P.left&&x<=W-P.right)svg+=`<line x1="${x.toFixed(1)}" y1="${P.top}" x2="${x.toFixed(1)}" y2="${H-P.bottom}" stroke="#EEF0F5" stroke-width="1"/>`;});
  }
  svg+=`<line x1="${P.left}" y1="${H-P.bottom}" x2="${W-P.right}" y2="${H-P.bottom}" stroke="#DDE1EB" stroke-width="1.5"/>`;
  svg+=`<line x1="${P.left}" y1="${P.top}" x2="${P.left}" y2="${H-P.bottom}" stroke="#DDE1EB" stroke-width="1.5"/>`;
  yTicks.forEach(v=>{const y=ty(v);if(y<P.top-2||y>H-P.bottom+2)return;svg+=`<line x1="${P.left-4}" y1="${y.toFixed(1)}" x2="${P.left}" y2="${y.toFixed(1)}" stroke="#DDE1EB" stroke-width="1"/>`;svg+=`<text x="${P.left-8}" y="${y.toFixed(1)}" text-anchor="end" dominant-baseline="middle" font-size="10" fill="#9AA3B4" font-family="DM Sans,sans-serif">${fmtY(v)}</text>`;});
  xTicks.forEach(v=>{const x=tx(v);if(x<P.left-2||x>W-P.right+2)return;svg+=`<line x1="${x.toFixed(1)}" y1="${H-P.bottom}" x2="${x.toFixed(1)}" y2="${H-P.bottom+4}" stroke="#DDE1EB" stroke-width="1"/>`;svg+=`<text x="${x.toFixed(1)}" y="${H-P.bottom+14}" text-anchor="middle" font-size="10" fill="#9AA3B4" font-family="DM Sans,sans-serif">${fmtX(v)}</text>`;});
  svg+=`<text x="${P.left+(cW/2)}" y="${H-10}" text-anchor="middle" font-size="11" fill="#4A5568" font-family="DM Sans,sans-serif" font-weight="600">Corrected OD (Absorbance)</text>`;
  svg+=`<text x="16" y="${P.top+cH/2}" text-anchor="middle" font-size="11" fill="#4A5568" font-family="DM Sans,sans-serif" font-weight="600" transform="rotate(-90,16,${P.top+cH/2})">Concentration (${u})</text>`;
  svg+=`<path d="${curveD}" fill="none" stroke="${cc}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>`;
  svg+=`<path d="${curveD} L${tx(xMax).toFixed(1)} ${ty(0).toFixed(1)} L${tx(xMin).toFixed(1)} ${ty(0).toFixed(1)} Z" fill="${cc}" opacity="0.04"/>`;
  pts.forEach(p=>{const cx=tx(p.x).toFixed(1),cy=ty(p.y).toFixed(1);svg+=`<circle cx="${cx}" cy="${cy}" r="${ps+2}" fill="rgba(255,255,255,0.9)"/>`;svg+=`<circle cx="${cx}" cy="${cy}" r="${ps}" fill="${pc}" stroke="#fff" stroke-width="1.5"/>`;svg+=`<title>${p.id}: OD=${fe(p.x,4)}, Conc=${fConc(p.y)} ${u}</title>`;});

  // ── ANNOTATION BOX - top-left corner, white background, never overlaps curve ──
  if(S.showEq&&co){
    const eqText=`Conc = ${fSci(co.a)}\u00d7OD\u00b2 ${co.b>=0?'+':''} ${fSci(co.b)}\u00d7OD ${co.c>=0?'+':''} ${fSci(co.c)}`;
    const r2v=r2Score(pts,co);
    const r2col=r2v&&r2v>0.999?'#2E7D32':r2v&&r2v>0.99?'#0A66C2':'#D50019';
    const r2txt=r2v!==null?`R\u00b2 = ${r2v.toFixed(5)}`:'';
    const boxW=Math.min(cW*0.60,340);
    svg+=`<rect x="${P.left+6}" y="${P.top+6}" width="${boxW}" height="40" rx="4" fill="rgba(255,255,255,.94)" stroke="rgba(10,102,194,.20)" stroke-width="1"/>`;
    svg+=`<text x="${P.left+12}" y="${P.top+21}" font-size="9.5" fill="${cc}" font-family="DM Sans,sans-serif" font-weight="700">${eqText}</text>`;
    svg+=`<text x="${P.left+12}" y="${P.top+36}" font-size="9.5" fill="${r2col}" font-family="DM Sans,sans-serif" font-weight="700">${r2txt}</text>`;
  }

  // ── LEGEND - two stacked lines, no key-text overlap ──
  const legY=H-P.bottom+26;
  svg+=`<rect x="${P.left+6}" y="${legY-8}" width="14" height="3" fill="${cc}" rx="1.5"/>`;
  svg+=`<text x="${P.left+24}" y="${legY-4}" font-size="10" fill="#4A5568" font-family="DM Sans,sans-serif">Fitted Polynomial (2nd Order)</text>`;
  svg+=`<circle cx="${P.left+13}" cy="${legY+10}" r="4" fill="${pc}" stroke="#fff" stroke-width="1"/>`;
  svg+=`<text x="${P.left+24}" y="${legY+13}" font-size="10" fill="#4A5568" font-family="DM Sans,sans-serif">Standard Data Points (n=${pts.length})</text>`;

  svg+='</svg>';
  svgEl.outerHTML=svg;
  const ns=document.getElementById('ab-chart-svg-inner');
  if(ns){ns.id='ab-chart-svg';ns.className='ab-ea-chart-svg';}
}

/* ── PLATE ── */
function renderPlate(){
  const tbl=document.getElementById('ab-plate-tbl');if(!tbl)return;
  const mode=S.plateMode,stdIds=new Set(S.standards.map(s=>s.id));
  const modeDesc={layout:'Assigning sample names',od:'Entering OD absorbance values',dilution:'Setting dilution factors'};
  const hint=document.getElementById('ab-plate-mode-desc');
  if(hint)hint.textContent=modeDesc[mode]||'';
  let html='<thead><tr><th></th>';
  COLS.forEach(c=>{html+=`<th>${c}</th>`;});
  html+='</tr></thead><tbody>';
  ROWS.forEach((row,r)=>{
    html+=`<tr><td class="rowlbl">${row}</td>`;
    COLS.forEach((_,c)=>{
      const name=S.layout[r][c],od=S.ods[r][c],dil=S.dilutions[name]||1;
      const isStd=stdIds.has(name),isBlk=name==='Blank';
      const focused=S.focusedCell&&S.focusedCell[0]===r&&S.focusedCell[1]===c;
      let cls='ab-ea-well';
      if(isStd&&!isBlk)cls+=' std';else if(isBlk)cls+=' blank';else if(name)cls+=' sample';
      if(focused)cls+=' focused';
      let inner=`<span class="ab-ea-well-pos">${row}${c+1}</span>`;
      if(focused){
        let itype='text',val=name,step='';
        if(mode==='od'){itype='number';val=od;step='step="0.001" min="0"';}
        if(mode==='dilution'){itype='number';val=dil;step='step="1" min="1"';}
        inner+=`<input id="ab-well-inp" type="${itype}" value="${val||''}" ${step} onblur="abEA.blurWell()" onkeydown="abEA.keyWell(event,${r},${c})" oninput="abEA.inputWell(this.value,${r},${c})" style="margin-top:4px" autofocus>`;
      } else {
        const dispName=mode==='dilution'&&name&&!isStd?(name+'<br><span style="font-size:8.5px;color:var(--ab-amber);font-weight:600">×'+dil+'</span>'):name;
        inner+=`<span class="ab-ea-well-name">${dispName||''}</span>`;
        if(mode==='od'&&od!==''&&od!==undefined)inner+=`<span class="ab-ea-well-od">${parseFloat(od).toFixed(3)}</span>`;
      }
      html+=`<td style="padding:0"><div class="${cls}" tabindex="0" onclick="abEA.focusWell(${r},${c})" onkeydown="abEA.keyWellNav(event,${r},${c})">${inner}</div></td>`;
    });
    html+='</tr>';
  });
  html+='</tbody>';
  tbl.innerHTML=html;
  if(S.focusedCell)setTimeout(()=>{const inp=document.getElementById('ab-well-inp');if(inp){inp.focus();inp.select();}},20);
}

/* ── RESULTS ── */
function renderResults(){
  const cont=document.getElementById('ab-results-content');if(!cont)return;
  const co=getCoeffs(),results=computeResults(),u=getUnits();
  const r2v=co?r2Score(getStdPoints(),co):null;
  const tab=document.getElementById('ab-results-tab');
  if(tab)tab.textContent=`Results${results.length?' ('+results.length+')':''}`;
  if(!co){cont.innerHTML=`<div class="ab-ea-notice ab-ea-notice-amber"><b>No standard curve:</b> Enter standard OD values on the Standards &amp; Curve tab first.</div>`;return;}
  const valid=results.filter(r=>!r.oor&&r.finalConc!==null);
  const oors=results.filter(r=>r.oor);
  const highCV=results.filter(r=>r.cvPct!==null&&r.cvPct>S.cvThresh);
  const allF=valid.map(r=>r.finalConc);
  const mean=allF.length?allF.reduce((a,x)=>a+x,0)/allF.length:null;
  const min=allF.length?Math.min(...allF):null,max=allF.length?Math.max(...allF):null;
  let html='';
  html+=`<div class="ab-ea-summcards">`;
  [{l:'Samples',v:results.length,c:'var(--ab-blue)'},{l:'Valid',v:valid.length,c:'var(--ab-green)'},{l:'OOR',v:oors.length,c:oors.length?'var(--ab-red)':'var(--ab-n400)'},{l:`Mean (${u})`,v:mean!==null?fConc(mean):'-',c:'var(--ab-blue)'},{l:`Min (${u})`,v:min!==null?fConc(min):'-',c:'var(--ab-n600)'},{l:`Max (${u})`,v:max!==null?fConc(max):'-',c:'var(--ab-n600)'},{l:'CV%>'+S.cvThresh+'%',v:highCV.length,c:highCV.length?'var(--ab-amber)':'var(--ab-n400)'},{l:'Curve R²',v:r2v!==null?r2v.toFixed(5):'-',c:r2v?r2v>0.999?'var(--ab-green)':r2v>0.99?'var(--ab-blue)':'var(--ab-red)':'var(--ab-n400)'}].forEach(({l,v,c})=>{html+=`<div class="ab-ea-summ"><div class="ab-ea-summ-n" style="color:${c}">${v}</div><div class="ab-ea-summ-lbl">${l}</div></div>`;});
  html+='</div>';
  if(oors.length)html+=`<div class="ab-ea-notice ab-ea-notice-red" style="margin-bottom:10px"><b>OOR:</b> ${oors.map(r=>r.name).join(', ')} - re-assay at appropriate dilution.</div>`;
  if(highCV.length)html+=`<div class="ab-ea-notice ab-ea-notice-amber" style="margin-bottom:10px"><b>High CV%:</b> ${highCV.map(r=>r.name+' ('+r.cvPct.toFixed(1)+'%)').join(', ')}.</div>`;
  if(!results.length){html+=`<div class="ab-ea-card"><div class="ab-ea-card-body" style="padding:48px;text-align:center;color:var(--ab-n400)"><div style="font-size:14px;font-weight:600;color:var(--ab-n600);margin-bottom:6px">No sample results</div><div style="font-size:12px">Assign sample names in the Plate Editor and enter OD values.</div></div></div>`;}
  else{
    html+=`<div class="ab-ea-card"><div class="ab-ea-tbl-wrap"><table class="ab-ea-tbl"><thead><tr><th>Sample</th><th>Wells</th><th>n</th><th>Avg OD</th><th>Corr. OD</th><th>Raw Conc (${u})</th><th>Dil.</th><th>Final Conc (${u})</th><th>CV%</th><th>Status</th></tr></thead><tbody>`;
    results.forEach((res,i)=>{
      const ok=!res.oor&&res.finalConc!==null&&res.finalConc>=0;
      const cvOk=res.cvPct===null||res.cvPct<=S.cvThresh;
      const statusHtml=res.oor?`<span class="ab-ea-oor">OOR</span>`:!cvOk?`<span class="ab-ea-warn">High CV</span>`:`<span class="ab-ea-valid">Valid</span>`;
      const cvHtml=res.cvPct!==null?`<span style="color:${res.cvPct>S.cvThresh?'var(--ab-amber)':res.cvPct>10?'var(--ab-n600)':'var(--ab-green)'}">${res.cvPct.toFixed(1)}%</span>`:'<span style="color:var(--ab-n400)">-</span>';
      html+=`<tr style="background:${i%2===0?'transparent':'#FAFBFC'}"><td style="font-weight:700">${res.name}</td><td style="font-size:11px;color:var(--ab-n400)">${res.wells.map(w=>w.well).join(', ')}</td><td style="text-align:center">${res.n}</td><td class="mono">${fe(res.avgOD,4)}</td><td class="mono blue">${fe(res.corrOD,4)}</td><td class="mono">${res.rawConc!==null?fConc(res.rawConc):'<span style="color:var(--ab-red)">OOR</span>'}</td><td style="padding:5px 8px"><input type="number" class="ab-ea-inp" style="width:56px;font-size:12px;text-align:center" value="${res.df}" min="1" step="1" onchange="abEA.setDilution('${res.name}',this.value)"></td><td class="mono" style="font-weight:700;color:${ok?'var(--ab-n800)':'var(--ab-red)'}">${ok?fConc(res.finalConc):'-'}</td><td>${cvHtml}</td><td>${statusHtml}</td></tr>`;
    });
    html+=`</tbody></table></div><div style="padding:10px 16px;border-top:1px solid var(--ab-n100);font-size:11px;color:var(--ab-n400)">OOR = Out Of Range · CV% from replicate wells · Final Conc = Raw Conc × Dilution Factor</div></div>`;
  }
  cont.innerHTML=html;
}

/* ── STATUS BAR ── */
function updateStatusBar(){
  const bar=document.getElementById('ab-statusbar');if(!bar)return;
  const pts=getStdPoints(),co=getCoeffs(),r2v=co?r2Score(pts,co):null;
  const results=computeResults();
  bar.innerHTML=[{l:'Blank OD',v:fe(getBlankOD(),4)},{l:'Standards',v:`${pts.length}/${S.standards.filter(s=>s.id!=='Blank').length}`},{l:'Samples',v:results.length||'-'},{l:'R²',v:r2v!==null?r2v.toFixed(4):'-'}].map(({l,v})=>`<div class="ab-ea-stat"><span class="ab-ea-stat-lbl">${l}</span><span class="ab-ea-stat-val">${v}</span></div>`).join('');
}

/* ── EXPORT EXCEL ── */
function doExcel(btn){
  const XLSX=window.XLSX;if(!XLSX){btn.innerHTML=btn._orig;btn.disabled=false;alert('Excel library failed to load.');return;}
  const u=getUnits(),co=getCoeffs(),pts=getStdPoints(),r2v=co?r2Score(pts,co):null,results=computeResults(),blankOD=getBlankOD();
  const wb=XLSX.utils.book_new();
  const sumData=[['ABMIUM ELISA Data Analysis Report'],[],['Assay Name',S.assayName||'-'],['Analyst',S.analyst||'-'],['Run Date',S.runDate||'-'],['ELISA Type',S.elisaType],['Units',u],['Notes',S.notes||'-'],[],['Polynomial','Concentration = a·OD² + b·OD + c'],['a',co?co.a:'-'],['b',co?co.b:'-'],['c',co?co.c:'-'],['R²',r2v!==null?r2v:'-'],['Blank Avg OD',blankOD||0]];
  const ws1=XLSX.utils.aoa_to_sheet(sumData);ws1['!cols']=[{wch:28},{wch:40}];XLSX.utils.book_append_sheet(wb,ws1,'Summary');
  const stdHdr=['ID',`Concentration (${u})`,'OD Rep 1','OD Rep 2','Avg OD','Corrected OD'];
  const stdRows=S.standards.map(s=>{const vs=[parseFloat(s.od1),parseFloat(s.od2)].filter(v=>!isNaN(v));const avg=vs.length?vs.reduce((a,x)=>a+x,0)/vs.length:null;const corr=avg!==null?(S.elisaType==='competitive'?avg:avg-blankOD):null;return[s.id,parseFloat(s.conc)||0,s.od1||'',s.od2||'',avg!==null?avg:'',corr!==null?corr:''];});
  const ws2=XLSX.utils.aoa_to_sheet([stdHdr,...stdRows]);ws2['!cols']=[{wch:10},{wch:20},{wch:12},{wch:12},{wch:12},{wch:14}];XLSX.utils.book_append_sheet(wb,ws2,'Standards');
  const lyH=['',1,2,3,4,5,6,7,8,9,10,11,12];const lyR=ROWS.map((row,r)=>[row,...COLS.map((_,c)=>S.layout[r][c]||'')]);
  const ws3=XLSX.utils.aoa_to_sheet([lyH,...lyR]);XLSX.utils.book_append_sheet(wb,ws3,'Plate Layout');
  const odH=['',1,2,3,4,5,6,7,8,9,10,11,12];const odR=ROWS.map((row,r)=>[row,...COLS.map((_,c)=>S.ods[r][c]!==''?parseFloat(S.ods[r][c])||'':'')]);
  const ws4=XLSX.utils.aoa_to_sheet([odH,...odR]);XLSX.utils.book_append_sheet(wb,ws4,'OD Values');
  const rHdr=['Sample','Wells','n','Avg OD','Corrected OD',`Raw Conc (${u})`,'Dilution Factor',`Final Conc (${u})`,'CV%','Status'];
  const rRows=results.map(res=>[res.name,res.wells.map(w=>w.well).join(', '),res.n,res.avgOD,res.corrOD,res.rawConc!==null?res.rawConc:'OOR',res.df,res.finalConc!==null?res.finalConc:'-',res.cvPct!==null?parseFloat(res.cvPct.toFixed(2)):'-',res.oor?'OOR':res.cvPct!==null&&res.cvPct>S.cvThresh?'High CV':'Valid']);
  const ws5=XLSX.utils.aoa_to_sheet([rHdr,...rRows]);ws5['!cols']=[{wch:14},{wch:22},{wch:5},{wch:12},{wch:14},{wch:16},{wch:14},{wch:16},{wch:8},{wch:10}];XLSX.utils.book_append_sheet(wb,ws5,'Results');
  const name=(S.assayName||'ELISA').replace(/[^a-zA-Z0-9_-]/g,'-')+'-'+new Date().toISOString().split('T')[0]+'.xlsx';
  XLSX.writeFile(wb,name);btn.innerHTML=btn._orig;btn.disabled=false;
}

/* ── EXPORT PDF ── */
function doPDF(btn){
  const {jsPDF}=window.jspdf;if(!jsPDF){btn.innerHTML=btn._orig;btn.disabled=false;alert('PDF library failed to load.');return;}
  const doc=new jsPDF({orientation:'portrait',unit:'mm',format:'a4'});
  const u=getUnits(),co=getCoeffs(),pts=getStdPoints(),r2v=co?r2Score(pts,co):null,results=computeResults(),blankOD=getBlankOD();
  const PAGE_W=210,PAGE_H=297,MAR=18;let y=MAR;const CW=PAGE_W-MAR*2;
  const addPage=()=>{doc.addPage();y=MAR;};
  const checkPage=need=>{if(y+need>PAGE_H-MAR)addPage();};

  // Header bar
  doc.setFillColor(10,102,194);doc.rect(0,0,PAGE_W,12,'F');
  doc.setFont('helvetica','bold');doc.setFontSize(9);doc.setTextColor(255,255,255);
  doc.text('ABMIUM',MAR,8);doc.setFont('helvetica','normal');
  doc.text('ELISA Data Analysis Report',MAR+20,8);
  doc.text(new Date().toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}),PAGE_W-MAR,8,{align:'right'});
  y=20;

  // Title
  doc.setFont('helvetica','bold');doc.setFontSize(16);doc.setTextColor(26,32,44);
  doc.text(S.assayName||'ELISA Analysis Report',MAR,y);y+=8;
  doc.setFont('helvetica','normal');doc.setFontSize(10);doc.setTextColor(74,85,104);
  doc.text(`${S.elisaType.charAt(0).toUpperCase()+S.elisaType.slice(1)} ELISA · Units: ${u} · Analyst: ${S.analyst||'-'} · Date: ${S.runDate||'-'}`,MAR,y);y+=6;
  if(S.notes){doc.setFontSize(9);doc.text('Notes: '+S.notes,MAR,y,{maxWidth:CW});y+=5;}
  y+=3;doc.setDrawColor(221,225,235);doc.setLineWidth(0.4);doc.line(MAR,y,PAGE_W-MAR,y);y+=5;

  // Parameters box
  if(co){
    doc.setFillColor(240,244,248);doc.roundedRect(MAR,y,CW,28,2,2,'F');
    doc.setFont('helvetica','bold');doc.setFontSize(8);doc.setTextColor(154,163,180);
    doc.text('POLYNOMIAL PARAMETERS',MAR+4,y+5);
    doc.setFont('courier','normal');doc.setFontSize(9.5);doc.setTextColor(10,102,194);
    doc.text(`Concentration = ${fSci(co.a)}\u00d7OD\u00b2  +  ${fSci(co.b)}\u00d7OD  +  ${fSci(co.c)}`,MAR+4,y+12);
    doc.setFont('helvetica','bold');doc.setFontSize(10);
    const r2col=r2v&&r2v>0.999?[46,125,50]:r2v&&r2v>0.99?[10,102,194]:[213,0,25];
    doc.setTextColor(...r2col);doc.text(`R\u00b2 = ${r2v!==null?r2v.toFixed(5):'-'}`,MAR+4,y+20);
    doc.setTextColor(74,85,104);doc.setFont('helvetica','normal');doc.setFontSize(9);
    doc.text(`Blank OD: ${fe(blankOD,4)}   Blank correction: ${S.elisaType==='competitive'?'None':'Applied'}   Standards: ${pts.length}`,MAR+50,y+20);
    y+=34;
  }

  // Chart
  const svgEl=document.getElementById('ab-chart-svg');
  if(svgEl&&co){
    try{
      const svgStr=new XMLSerializer().serializeToString(svgEl);
      const canvas=document.createElement('canvas');canvas.width=SVG_W*2;canvas.height=SVG_H*2;
      const ctx=canvas.getContext('2d'),img=new Image();
      img.onload=()=>{
        ctx.drawImage(img,0,0,canvas.width,canvas.height);
        const imgData=canvas.toDataURL('image/png');
        checkPage(80);
        doc.setFont('helvetica','bold');doc.setFontSize(9);doc.setTextColor(26,32,44);
        doc.text('STANDARD CURVE',MAR,y);y+=4;
        // Chart width full, height proportional to SVG aspect
        const chartH=CW*SVG_H/SVG_W;
        doc.addImage(imgData,'PNG',MAR,y,CW,chartH);y+=chartH+5;
        finishPDF();
      };
      img.onerror=()=>finishPDF();
      img.src=URL.createObjectURL(new Blob([svgStr],{type:'image/svg+xml;charset=utf-8'}));
      return;
    }catch(e){finishPDF();}
  } else {finishPDF();}

  function drawTable(hdr,rows,x,y,totalW,colWs,fs){
    const ROW_H=5,H_H=5.5;doc.setFontSize(fs||8);
    if(hdr){
      doc.setFillColor(247,248,250);doc.rect(x,y,totalW,H_H,'F');
      doc.setDrawColor(221,225,235);doc.setLineWidth(0.3);doc.rect(x,y,totalW,H_H,'S');
      doc.setFont('helvetica','bold');doc.setTextColor(74,85,104);
      let cx=x;hdr.forEach((h,i)=>{doc.text(h,cx+1.5,y+3.8,{maxWidth:(colWs[i]||16)-2});cx+=colWs[i]||16;});
      y+=H_H;
    }
    rows.forEach((row,ri)=>{
      doc.setFillColor(ri%2===0?255:250,ri%2===0?255:251,ri%2===0?255:252);
      doc.rect(x,y,totalW,ROW_H,'F');doc.setDrawColor(240,244,248);doc.rect(x,y,totalW,ROW_H,'S');
      doc.setFont('helvetica','normal');
      let cx=x;
      row.forEach((cell,i)=>{
        const s=String(cell);
        if(s==='OOR'||s.includes('OOR'))doc.setTextColor(213,0,25);
        else if(s==='OK'||s==='Valid')doc.setTextColor(46,125,50);
        else doc.setTextColor(26,32,44);
        doc.text(s,cx+1.5,y+3.5,{maxWidth:(colWs[i]||16)-2});cx+=colWs[i]||16;
      });
      y+=ROW_H;
    });
    return y;
  }

  function finishPDF(){
    // Standards
    checkPage(40);
    doc.setFont('helvetica','bold');doc.setFontSize(9);doc.setTextColor(26,32,44);
    doc.text('STANDARDS',MAR,y);y+=4;
    const sHdr=['ID',`Conc (${u})`,'OD Rep 1','OD Rep 2','Avg OD','Corr. OD'];
    const sRows=S.standards.map(s=>{const vs=[parseFloat(s.od1),parseFloat(s.od2)].filter(v=>!isNaN(v));const avg=vs.length?vs.reduce((a,x)=>a+x,0)/vs.length:null;const corr=avg!==null?(S.elisaType==='competitive'?avg:avg-blankOD):null;return[s.id,s.conc||'-',s.od1||'-',s.od2||'-',avg!==null?fe(avg,4):'-',corr!==null?fe(corr,4):'-'];});
    y=drawTable(sHdr,sRows,MAR,y,CW,[18,28,20,20,20,20],8)+4;
    // Results
    if(results.length){
      checkPage(50);
      doc.setFont('helvetica','bold');doc.setFontSize(9);doc.setTextColor(26,32,44);
      doc.text('RESULTS',MAR,y);y+=4;
      const rHdr=['Sample','n','Avg OD','Corr. OD',`Conc (${u})`,'D.F.',`Final (${u})`,'CV%','Status'];
      const rRows=results.map(res=>[res.name,res.n.toString(),fe(res.avgOD,4),fe(res.corrOD,4),res.rawConc!==null?fConc(res.rawConc):'OOR',res.df.toString(),res.finalConc!==null?fConc(res.finalConc):'-',res.cvPct!==null?res.cvPct.toFixed(1)+'%':'-',res.oor?'OOR':res.cvPct!==null&&res.cvPct>S.cvThresh?'HiCV':'Valid']);
      const rW=[22,8,18,18,24,10,24,14,14];
      let chunk=0;
      while(chunk<rRows.length){
        const spaceLeft=PAGE_H-MAR-y,fits=Math.max(1,Math.floor((spaceLeft-7.5)/5));
        const slice=rRows.slice(chunk,chunk+fits);
        y=drawTable(chunk===0?rHdr:null,slice,MAR,y,CW,rW,8)+2;
        chunk+=fits;if(chunk<rRows.length)addPage();
      }
    }
    // Footer
    const total=doc.internal.getNumberOfPages();
    for(let p=1;p<=total;p++){
      doc.setPage(p);
      doc.setFillColor(10,102,194);doc.rect(0,PAGE_H-8,PAGE_W,8,'F');
      doc.setFont('helvetica','normal');doc.setFontSize(7);doc.setTextColor(255,255,255);
      doc.text('ABMIUM ELISA Data Analysis  |  Generated with ABMIUM ELISA Analyser',MAR,PAGE_H-3);
      doc.text(`Page ${p} of ${total}`,PAGE_W-MAR,PAGE_H-3,{align:'right'});
    }
    const name=(S.assayName||'ELISA').replace(/[^a-zA-Z0-9_-]/g,'-')+'-'+new Date().toISOString().split('T')[0]+'.pdf';
    doc.save(name);btn.innerHTML=btn._orig;btn.disabled=false;
  }
}

/* ── PUBLIC API ── */
window.abEA={
  setTab(id,btn){
    document.querySelectorAll('.ab-ea-tab').forEach(t=>t.classList.remove('active'));
    if(btn)btn.classList.add('active');
    document.querySelectorAll('.ab-ea-panel').forEach(p=>p.classList.remove('active'));
    const panel=document.getElementById('ab-panel-'+id);if(panel)panel.classList.add('active');
    if(id==='results')renderResults();
    if(id==='plate')renderPlate();
  },
  setPlateMode(mode,el){S.plateMode=mode;S.focusedCell=null;document.querySelectorAll('.ab-ea-pmode').forEach(b=>b.classList.remove('active'));if(el)el.classList.add('active');renderPlate();},
  focusWell(r,c){S.focusedCell=[r,c];renderPlate();},
  blurWell(){setTimeout(()=>{if(S.focusedCell){S.focusedCell=null;renderPlate();}},150);},
  inputWell(val,r,c){
    if(S.plateMode==='layout')S.layout[r][c]=val;
    else if(S.plateMode==='od')S.ods[r][c]=val;
    else if(S.plateMode==='dilution'){const nm=S.layout[r][c];if(nm)S.dilutions[nm]=val;}
    save();updateStatusBar();
  },
  keyWell(e,r,c){
    if(e.key==='Enter'||e.key==='Tab'){
      e.preventDefault();
      const val=e.target.value;
      if(S.plateMode==='layout')S.layout[r][c]=val;
      else if(S.plateMode==='od')S.ods[r][c]=val;
      else if(S.plateMode==='dilution'){const nm=S.layout[r][c];if(nm)S.dilutions[nm]=val;}
      S.focusedCell=c<11?[r,c+1]:r<7?[r+1,0]:null;
      save();renderPlate();
    }
    if(e.key==='Escape'){S.focusedCell=null;renderPlate();}
    if(e.key==='ArrowRight'&&c<11){e.preventDefault();S.focusedCell=[r,c+1];renderPlate();}
    if(e.key==='ArrowLeft'&&c>0){e.preventDefault();S.focusedCell=[r,c-1];renderPlate();}
    if(e.key==='ArrowDown'&&r<7){e.preventDefault();S.focusedCell=[r+1,c];renderPlate();}
    if(e.key==='ArrowUp'&&r>0){e.preventDefault();S.focusedCell=[r-1,c];renderPlate();}
  },
  keyWellNav(e,r,c){if(e.key==='Enter'||e.key===' '){e.preventDefault();this.focusWell(r,c);}},
  updateStd(i,field,val){S.standards[i][field]=val;_cc=null;renderStdTable();updateStatusBar();save();},
  addStandard(){const nb=S.standards.filter(s=>s.id!=='Blank'),bl=S.standards.find(s=>s.id==='Blank');S.standards=[...nb,{id:'STD'+(nb.length+1),conc:'',od1:'',od2:''},...(bl?[bl]:[])];_cc=null;renderStdTable();save();},
  removeLastStandard(){const nb=S.standards.filter(s=>s.id!=='Blank');if(nb.length<=2)return;const bl=S.standards.find(s=>s.id==='Blank');S.standards=[...nb.slice(0,-1),...(bl?[bl]:[])];_cc=null;renderStdTable();save();},
  removeStd(i){S.standards=S.standards.filter((_,idx)=>idx!==i);_cc=null;renderStdTable();save();},
  setDilution(name,val){S.dilutions[name]=parseFloat(val)||1;save();},
  setUnits(val){S.units=val;document.getElementById('ab-custom-units-row').style.display=val==='custom'?'block':'none';renderStdTable();renderCurveInfo();save();},
  toggle(id){const key={grid:'showGrid',eq:'showEq'}[id];if(!key)return;S[key]=!S[key];const btn=document.getElementById('ab-tog-'+id);if(btn){btn.style.background=S[key]?'#0A66C2':'#DDE1EB';btn.querySelector('.knob').style.left=S[key]?'21px':'3px';}renderChart(getCoeffs(),getStdPoints());save();},
  toggleLogScale(){S.logScale=!S.logScale;const b=document.getElementById('ab-log-btn');if(b)b.textContent=S.logScale?'Log':'Linear';renderChart(getCoeffs(),getStdPoints());},
  syncColor(which){const txt=document.getElementById('ab-'+which+'-color-txt'),col=document.getElementById('ab-'+which+'-color');if(txt&&col&&/^#[0-9a-fA-F]{6}$/.test(txt.value)){col.value=txt.value;S[which==='curve'?'curveColor':'ptColor']=txt.value;renderChart(getCoeffs(),getStdPoints());save();}},
  updateChart(){const cc=document.getElementById('ab-curve-color'),pc=document.getElementById('ab-pt-color'),ps=document.getElementById('ab-pt-size');if(cc){S.curveColor=cc.value;document.getElementById('ab-curve-color-txt').value=cc.value;}if(pc){S.ptColor=pc.value;document.getElementById('ab-pt-color-txt').value=pc.value;}if(ps)S.ptSize=parseInt(ps.value);renderChart(getCoeffs(),getStdPoints());save();},
  openSettings(){document.getElementById('ab-overlay').classList.add('open');document.getElementById('ab-drawer').classList.add('open');},
  closeSettings(){document.getElementById('ab-overlay').classList.remove('open');document.getElementById('ab-drawer').classList.remove('open');renderStdTable();},
  resetPlate(){if(!confirm('Reset all plate data?'))return;S.layout=makeDefaultLayout();S.ods=Array.from({length:8},()=>Array(12).fill(''));S.dilutions={};save();renderPlate();},
  confirmReset(){if(!confirm('Reset ALL data? This cannot be undone.'))return;localStorage.removeItem(LS_KEY);location.reload();},
  pasteODs(){const m=document.getElementById('ab-paste-modal');if(m)m.style.display=m.style.display==='none'?'block':'none';},
  applyPastedODs(){
    const raw=document.getElementById('ab-paste-area').value.trim();if(!raw)return;
    const lines=raw.split('\n').map(l=>l.trim()).filter(Boolean);
    const newODs=Array.from({length:8},()=>Array(12).fill(''));let warns=0;
    lines.slice(0,8).forEach((line,r)=>{line.split(/\t|,/).map(c=>c.trim()).slice(0,12).forEach((v,c)=>{const n=parseFloat(v);if(!isNaN(n)&&n>=0)newODs[r][c]=v;else if(v!=='')warns++;});});
    S.ods=newODs;document.getElementById('ab-paste-modal').style.display='none';document.getElementById('ab-paste-area').value='';
    if(warns)alert(`Applied. ${warns} non-numeric cell(s) left empty.`);
    save();renderPlate();updateStatusBar();
  },
  exportExcel(btn){btn._orig=btn.innerHTML;btn.innerHTML='<span class="ab-ea-spin"></span>';btn.disabled=true;if(window.XLSX){doExcel(btn);}else{const s=document.createElement('script');s.src='https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';s.onload=()=>doExcel(btn);s.onerror=()=>{btn.innerHTML=btn._orig;btn.disabled=false;alert('Could not load Excel library.');};document.head.appendChild(s);}},
  exportPDF(btn){btn._orig=btn.innerHTML;btn.innerHTML='<span class="ab-ea-spin"></span>';btn.disabled=true;if(window.jspdf){doPDF(btn);}else{const s=document.createElement('script');s.src='https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';s.onload=()=>doPDF(btn);s.onerror=()=>{btn.innerHTML=btn._orig;btn.disabled=false;alert('Could not load PDF library.');};document.head.appendChild(s);}},

  setElisaType(v){S.elisaType=v;_cc=null;syncSettingsUI();renderStdTable();updateStatusBar();save();},

  /* ── LOAD EXAMPLE - Human IL-6 Sandwich ELISA, clean duplicate pairs, 5 OOR ── */
  loadExample(){
    S.elisaType='sandwich';S.units='pg/ml';
    S.assayName='Human IL-6 ELISA \u2014 Example Run';
    S.analyst='ABMIUM Lab';S.runDate=new Date().toISOString().split('T')[0];S.notes='';
    S.standards=[
      {id:'STD1',conc:'2000', od1:'1.006',od2:'0.928'},
      {id:'STD2',conc:'1000', od1:'0.645',od2:'0.618'},
      {id:'STD3',conc:'500',  od1:'0.411',od2:'0.381'},
      {id:'STD4',conc:'250',  od1:'0.242',od2:'0.242'},
      {id:'STD5',conc:'125',  od1:'0.153',od2:'0.165'},
      {id:'STD6',conc:'62.5', od1:'0.113',od2:'0.121'},
      {id:'STD7',conc:'31.25',od1:'0.094',od2:'0.091'},
      {id:'Blank',conc:'0',   od1:'0.072',od2:'0.069'},
    ];
    S.layout=makeDefaultLayout();
    // 8 rows × 12 cols - clean duplicate pairs per sample (CV<8%), OOR: S4 (high), S8 (low), S12 (low), S16 (high), S32 (low)
    const rawODs=[
      [1.006,0.928,0.368,0.616,0.779,0.400,0.232,0.569,0.276,0.825,0.740,0.502],
      [0.645,0.618,0.374,0.624,0.785,0.407,0.238,0.575,0.282,0.832,0.747,0.508],
      [0.411,0.381,0.545,0.263,0.305,0.696,0.474,0.184,0.351,0.226,0.435,0.892],
      [0.242,0.242,0.552,0.270,0.312,0.703,0.480,0.190,0.357,0.232,0.442,0.901],
      [0.153,0.165,0.878,0.144,0.118,0.948,0.762,0.095,0.666,0.123,0.167,0.331],
      [0.113,0.121,0.888,0.150,0.122,0.956,0.769,0.099,0.673,0.129,0.172,0.337],
      [0.094,0.091,1.012,0.082,0.080,1.038,0.109,0.293,0.920,0.079,0.104,0.609],
      [0.072,0.069,1.025,0.085,0.083,1.045,0.115,0.299,0.929,0.082,0.110,0.616],
    ];
    S.ods=rawODs.map(row=>row.map(v=>v.toString()));
    S.dilutions={};_cc=null;
    this.closeSettings();syncSettingsUI();renderStdTable();renderPlate();updateStatusBar();
    alert('Loaded: Human IL-6 ELISA \u2014 8 standards, 40 samples, Sandwich ELISA, pg/ml.');
  },
};

/* ── PERSISTENCE ── */
function save(){try{localStorage.setItem(LS_KEY,JSON.stringify({...S,focusedCell:null}));}catch(e){}}
function load(){try{const d=JSON.parse(localStorage.getItem(LS_KEY)||'null');if(d){Object.assign(S,d);S.focusedCell=null;}}catch(e){}}

function syncSettingsUI(){
  const sv=(id,v)=>{const el=document.getElementById(id);if(el)el.value=v;};
  sv('ab-assay-name',S.assayName);sv('ab-analyst',S.analyst);sv('ab-run-date',S.runDate);
  sv('ab-notes',S.notes);sv('ab-units-sel',S.units);sv('ab-custom-units-inp',S.customUnits);
  sv('ab-cv-thresh',S.cvThresh);sv('ab-curve-color',S.curveColor);sv('ab-curve-color-txt',S.curveColor);
  sv('ab-pt-color',S.ptColor);sv('ab-pt-color-txt',S.ptColor);sv('ab-pt-size',S.ptSize);
  document.getElementById('ab-custom-units-row').style.display=S.units==='custom'?'block':'none';
  ['grid','eq'].forEach(id=>{const key={grid:'showGrid',eq:'showEq'}[id];const btn=document.getElementById('ab-tog-'+id);if(btn){btn.style.background=S[key]?'#0A66C2':'#DDE1EB';btn.querySelector('.knob').style.left=S[key]?'21px':'3px';}});
  const tg=document.getElementById('ab-type-grid');
  if(tg)tg.innerHTML=TYPES.map(t=>`<button class="ab-ea-type-opt${S.elisaType===t.v?' active':''}" onclick="abEA.setElisaType('${t.v}')"><div>${t.l}</div><div style="font-size:9px;font-weight:400;opacity:.7;margin-top:2px">${t.d}</div></button>`).join('');
  const badge=document.getElementById('ab-type-badge');
  if(badge){badge.textContent=TYPES.find(t=>t.v===S.elisaType)?.l||S.elisaType;badge.className='ab-ea-badge ab-ea-badge--'+S.elisaType;}
  const sub=document.getElementById('ab-std-sub');
  if(sub)sub.textContent=`${S.elisaType==='competitive'?'Competitive - raw OD (no blank subtraction)':'Blank subtraction applied'} · Units: ${getUnits()}`;
}

['ab-assay-name','ab-analyst','ab-run-date','ab-notes','ab-cv-thresh','ab-custom-units-inp'].forEach(id=>{
  const el=document.getElementById(id);
  if(el)el.addEventListener('input',()=>{
    if(id==='ab-assay-name')S.assayName=el.value;
    if(id==='ab-analyst')S.analyst=el.value;
    if(id==='ab-run-date')S.runDate=el.value;
    if(id==='ab-notes')S.notes=el.value;
    if(id==='ab-cv-thresh')S.cvThresh=parseFloat(el.value)||15;
    if(id==='ab-custom-units-inp'){S.customUnits=el.value;renderStdTable();renderCurveInfo();}
    save();
  });
});

function init(){
  load();
  if(!S.layout)S.layout=makeDefaultLayout();
  if(!S.ods)S.ods=Array.from({length:8},()=>Array(12).fill(''));
  syncSettingsUI();renderStdTable();renderPlate();updateStatusBar();
  if(!S.runDate){const d=new Date().toISOString().split('T')[0];S.runDate=d;const el=document.getElementById('ab-run-date');if(el)el.value=d;}
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();

})();
